import emojis from './emojis'

export default function ($container, options) {
    var that = this;

    var $toolbar,
        $emojisIcon,
        $emojisPopup,
        $emojisMenu,
        $emojisCategory,
        $emojisCategoryTitle,
        $emojisCategoryList,
        $personalizationIcon,
        $personalizationPopup,
        $formFieldPopup,
        $formFieldIcon,
        $snippetIcon,
        $snippetPopup,
        $optimoveIcon,
        $optimovePopup,
        $salesforceIcon,
        $salesforcePopup,
        $consentPreferencesIcon,
        $consentPreferencesPopup
            = null;

    this.emojisCategory = null;

    this.init = function() {
        if (!$container.length) return;

        $toolbar = $('<div class="contentEditorToolbar"></div>');

        if (options.emojis) {
            $container.addClass('emojisEditor');
            this.initEmojisIcon();
            this.initEmojisPopup();
        }

        if (options.personalization) {
            $container.addClass('personalizationEditor');
            this.initPersonalizationIcon();
            this.initPersonalizationPopup();
        }

        if (options.snippets) {
            var html;
            if(options.wysiwyg){
                html = 1;
            }
            $container.addClass('snippetEditor');
            this.initSnippetIcon();
            this.initSnippetPopup(html);
        }

        if (options.optimove) {
            $container.addClass('optimoveEditor');
            this.initOptimoveIcon();
            this.initOptimovePopup();
        }
        if (options.salesforce) {
            $container.addClass('salesforceEditor');
            this.initSalesforceIcon();
            this.initSalesforcePopup();
        }

        if (options.form_field) {
          $container.addClass('formFieldEditor');
          this.initFormFieldIcon();
          this.initFormFieldPopup();
        }

        if (options.consentPreferences) {
            $container.addClass('consentPreferencesEditor');
            this.initConsentPreferencesIcon();
            this.initConsentPreferencesPopup();
        }

        this.initWysiwyg();

        $container.data('contentEditor', this);
        $container.addClass('contentEditor');
       if (options.emojis && !options.emojisButton
               || options.personalization && !options.personalizationButton
               || options.snippets && !options.snippetButton
               || options.optimove && !options.optimoveButton
               || options.salesforce && !options.salesforceButton
               || options.form_field
               || options.consentPreferences && !options.consentPreferencesButton) {
            $container.append($toolbar);
       }
    };


    this.initEmojisIcon = function() {
        if (options.emojisButton) {
            $emojisIcon = options.emojisButton;
        } else {
            $emojisIcon = $('<span>☺</span>');
            $toolbar.append($emojisIcon);
        }
        $emojisIcon.mousedown(function(){
            if (options.wysiwyg === 'redactor') {
                $container.find('textarea').eq(0).redactor('selection.save');
            }
        });
        $emojisIcon.click(function(e){
            that.toggleEmojisPopup();
            e.stopPropagation();
            return false;
        });
    };

    this.initEmojisPopup = function() {
        $emojisPopup = $('<div class="emojisPopup"></div>');

        $emojisMenu = $('<div class="emojisMenu"></div>');
        for (var i = 0; i < emojis.length; i++) {
            var $emojisItem = $('<span title="'+emojis[i].title+'" data-category="'+i+'">'+emojis[i].icon+'</span>');
            $emojisItem.addClass('emojisItem');
            $emojisMenu.append($emojisItem);
        }
        $emojisPopup.append($emojisMenu);

        $emojisCategory = $('<div class="emojisCategory"></div>');
        $emojisCategoryTitle = $('<div class="emojisTitle"></div>');
        $emojisCategoryList = $('<div class="emojisList"></div>');
        $emojisCategory.append($emojisCategoryTitle);
        $emojisCategory.append($emojisCategoryList);
        $emojisPopup.append($emojisCategory);

        $emojisMenu.on('click', 'span', function(){
            that.renderEmojisCategory($(this).data('category'));
        });

        $emojisCategoryList.on('click', 'span', function(){
            that.insertTag($(this).text());
            that.closeEmojisPopup();
        });

        $emojisPopup.mousedown(function(e) {
            e.stopPropagation();
        });

        $container.append($emojisPopup);
    };

    this.toggleEmojisPopup = function() {
        if ($emojisPopup.is(':visible')) {
            this.closeEmojisPopup();
        } else {
            this.openEmojisPopup();
        }
    };

    this.openEmojisPopup = function() {
        this.positionPopup($emojisPopup, $emojisIcon);
        $emojisPopup.fadeIn(200);
        $("body").bind('mousedown', this.closeEmojisPopup);
        if (this.emojisCategory === null) {
            this.renderEmojisCategory(0);
        }
    };

    this.closeEmojisPopup = function() {
        $("body").unbind('mousedown', this.closeEmojisPopup);
        $emojisPopup.fadeOut(200);
    };

    this.renderEmojisCategory = function(category) {
        this.emojisCategory = category;
        $emojisCategoryTitle.text(emojis[category].title);
        $emojisCategoryList.html('');
        for (var i = 0; i < emojis[category].icons.length; i++) {
            var $emojisItem = $('<span title="'+emojis[category].icons[i][1]+'">'+emojis[category].icons[i][0]+'</span>');
            $emojisCategoryList.append($emojisItem);
            if ($emojisItem.width() && $emojisItem.width() < 30) {
                $emojisItem.addClass('emojisItem');
            } else {
                $emojisItem.remove();
            }
        }
    };

    this.initFormFieldIcon = function() {
        $formFieldIcon = $('<i class="icon iconp-curly-brackets"></i>')
        $toolbar.append($formFieldIcon)
        $formFieldIcon.mousedown(function() {
            if (options.wysiwyg === 'redactor') {
                $container
                    .find('textarea')
                    .eq(0)
                    .redactor('selection.save')
            }
        })
        $formFieldIcon.click(function(e) {
            that.toggleFormFieldPopup()
            e.stopPropagation()
            return false
        })
    }

    this.initFormFieldPopup = function() {
        $formFieldPopup = $(
            '<div class="formFieldPopup personalizationPopup">' +
                '<label class="label1">' +
                    t('all', 'Campaign__Push_select_form_field') +
                '</label> <br> <input type="text" class="helper" />' +
                '<p class="field-error"></p>' +
            '</div>',
        )

        $formFieldPopup.find('input').on('keyup', function(e) {
            let errorMessage = $formFieldPopup.find('.field-error')
            if (errorMessage.text()) {
                errorMessage.text('')
                errorMessage.css('padding-top', '0px')
            }
            if (e.key === 'Enter' || e.keyCode === 13) {
                if (this.value.match('^[A-z0-9_-]+$')) {
                    that.closeFormFieldPopup()
                    that.insertTag('{{ field["' + this.value + '"] }}')
                } else {
                    that.showError()
                }
            }
        })

        $formFieldPopup.mousedown(function(e) {
            e.stopPropagation()
        })

        $container.append($formFieldPopup)
    }

    this.showError = function() {
        let fieldName = $formFieldPopup.find('input').val()
        let errorMessage = $formFieldPopup.find('.field-error')
        errorMessage.text(t('all', 'PushCampaign__placeholder_invalid', {placeholder: fieldName}))
        errorMessage.css("padding-top", '5px')
    }
    this.closeFormFieldPopup = function() {
        $('body').unbind('mousedown', this.closeFormFieldPopup)
        $formFieldPopup.fadeOut(200)
        setTimeout(function() {
            $formFieldPopup.find('input').val('')
        }, 0)
    }
    this.toggleFormFieldPopup = function() {
        if ($formFieldPopup.is(':visible')) {
            this.closeFormFieldPopup()
        } else {
            this.openFormFieldPopup()
        }
    }
    this.openFormFieldPopup = function() {
        this.positionPopup($formFieldPopup, $formFieldIcon)
        $formFieldPopup.fadeIn(200)
        $formFieldPopup.find('input').focus()
        $('body').bind('mousedown', this.closeFormFieldPopup)
    }

    this.initPersonalizationIcon = function() {
        if (options.personalizationButton) {
            $personalizationIcon = options.personalizationButton;
        } else {
            $personalizationIcon = $('<i class="icon iconp-user-1"></i>');
            $toolbar.append($personalizationIcon);
        }
        $personalizationIcon.mousedown(function(){
            if (options.wysiwyg === 'redactor') {
                $container.find('textarea').eq(0).redactor('selection.save');
            }
        });
        $personalizationIcon.click(function(e){
            that.togglePersonalizationPopup();
            e.stopPropagation();
            return false;
        });
    };

    this.initPersonalizationPopup = function() {
        $personalizationPopup = $(
            '<div class="personalizationPopup">'+
                '<label class="label1">'+t('all', 'Campaign__Push_select_attribute')+'</label>'+
                '<br>'+
                '<input type="text" class="jsAutocomplete helper" />'+
            '</div>');

        var restBaseUrl = (window.xp && window.xp.restUrl) ? window.xp.restUrl :
            window.location.protocol + '//rest.' + window.location.hostname + ':3043';
        var tagsUrl = restBaseUrl + '/projects/' + this.getProjectId() + '/tags';

        $personalizationPopup.find('.jsAutocomplete').tagAutocomplete({
            appendTo: '#content-container',
            params: null,
            source: function(request, response) {
                let queryParams = new URLSearchParams({
                    sort: 'title',
                    show_aliases: 0,
                    attribute: 1,
                    title: request.term || ''
                });

                $.ajax({
                    url: tagsUrl + '?' + queryParams.toString(),
                    method: 'GET',
                    crossDomain: true,
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + (window.xp && window.xp.accessToken ? window.xp.accessToken : '')
                    },
                    success: function(data) {
                        let items = Array.isArray(data) ? data.map(function(item) {
                            let name = item.name || item.value;
                            return { value: name, label: name };
                        }) : [];
                        response(items);
                    },
                    error: function(xhr, status, error) {
                        console.error('Failed to load tags:', error);
                        response([]);
                    }
                });
            },
            searchOnFocus: {
                allowEmptyValue: true,
                allowFilledValue: true
            },
            select: function( event, ui ) {
              let check = ui.item.value.match("^[a-zA-Z]+[a-zA-Z0-9_.]{0,}$");
              if (window.vue.$store.state.app.features.twig) {
                if (check) {
                  that.insertTag('{{ ' + ui.item.value + ' }}');
                } else {
                  let path = ui.item.value.replaceAll(`'`, `\\'`)
                  that.insertTag('{{ user.attributes[\'' + path + '\'] }}');
                }
              }else{
                that.insertTag('{{ ' + ui.item.value + ' }}');
              }
              return false;
            }
        });

        $personalizationPopup.find('.jsRemoveButton').click(function() {
            that.closePersonalizationPopup();
        });

        $personalizationPopup.mousedown(function(e) {
            e.stopPropagation();
        });

        $container.append($personalizationPopup);
    };

    this.togglePersonalizationPopup = function() {
        if ($personalizationPopup.is(':visible')) {
            this.closePersonalizationPopup();
        } else {
            this.openPersonalizationPopup();
        }
    };

    this.openPersonalizationPopup = function() {
        this.positionPopup($personalizationPopup, $personalizationIcon);
        $personalizationPopup.fadeIn(200);
        $personalizationPopup.find('.jsAutocomplete').focus();
        $("body").bind('mousedown', this.closePersonalizationPopup);
    };

    this.closePersonalizationPopup = function() {
        $("body").unbind('mousedown', this.closePersonalizationPopup);
        $personalizationPopup.fadeOut(200);
        setTimeout(function() {
            $personalizationPopup.find('.jsAutocomplete').val('');
        }, 0);
    };

    this.initSnippetIcon = function() {
        if (options.snippetButton) {
            $snippetIcon = options.snippetButton;
        } else {
            $snippetIcon = $('<i class="icon icon-code"></i>');
            $toolbar.append($snippetIcon);
        }
        $snippetIcon.mousedown(function(){
            if (options.wysiwyg === 'redactor') {
                $container.find('textarea').eq(0).redactor('selection.save');
            }
        });
        $snippetIcon.click(function(e){
            that.toggleSnippetPopup();
            e.stopPropagation();
            return false;
        });
    };

    this.initSnippetPopup = function(html) {
        $snippetPopup = $(
            '<div class="snippetPopup">'+
            '<label class="label1">'+t('all', 'Campaign__Push_select_snippet')+'</label>'+
            '<br>'+
            '<input type="text" class="jsAutocomplete" />'+
            '</div>');

        let source = html
            ? '/api/content/snippet/autocomplete?project_id=' + this.getProjectId()
            : '/api/content/snippet/autocomplete?project_id=' + this.getProjectId() + '&type=1';

        $snippetPopup.find('.jsAutocomplete').tagAutocomplete({
          appendTo: '#content-container',
          source: source,
          searchOnFocus: {
            allowEmptyValue: true,
            allowFilledValue: true
          },
          select: function(event, ui) {
            that.insertTag('{{ snippet("' + ui.item.value + '") }}')
            return false
          }
        })

        $snippetPopup.find('.jsAutocomplete').on('input', function() {
          var $input = $(this)
          if (!$input.val()) {
            $input.tagAutocomplete('option', 'minLength', 0)
            $input.tagAutocomplete('search', '')
          } else {
            $input.tagAutocomplete('option', 'minLength', 1)
          }
        })

        $snippetPopup.find('.jsRemoveButton').click(function() {
            that.closeSnippetPopup();
        });

        $snippetPopup.mousedown(function(e) {
            e.stopPropagation();
        });

        $container.append($snippetPopup);
    };

    this.toggleSnippetPopup = function() {
        if ($snippetPopup.is(':visible')) {
            this.closeSnippetPopup();
        } else {
            this.openSnippetPopup();
        }
    };

    this.openSnippetPopup = function() {
        this.positionPopup($snippetPopup, $snippetIcon);
        $snippetPopup.fadeIn(200);
        $snippetPopup.find('.jsAutocomplete').focus();
        $("body").bind('mousedown', this.closeSnippetPopup);
    };

    this.closeSnippetPopup = function() {
        $("body").unbind('mousedown', this.closeSnippetPopup);
        $snippetPopup.fadeOut(200);
        setTimeout(function() {
            $snippetPopup.find('.jsAutocomplete').val('');
        }, 0);
    };

    this.initOptimoveIcon = function() {
        if (options.optimoveButton) {
            $optimoveIcon = options.optimoveButton;
        } else {
            $optimoveIcon = $('<i class="icon iconp-Optimove-Head"></i>');
            $toolbar.append($optimoveIcon);
        }
        $optimoveIcon.mousedown(function(){
            if (options.wysiwyg === 'redactor') {
                $container.find('textarea').eq(0).redactor('selection.save');
            }
        });
        $optimoveIcon.click(function(e){
            that.toggleOptimovePopup();
            e.stopPropagation();
            return false;
        });
    };

    this.initOptimovePopup = function() {
        $optimovePopup = $(
            '<div class="personalizationPopup">'+
            '<label class="label1">'+t('all', 'Campaign__Optimove_select_attribute')+'</label>'+
            '<br>'+
            '<input type="text" class="jsAutocomplete" />'+
            '</div>');

        $optimovePopup.find('.jsAutocomplete').tagAutocomplete({
            appendTo: '#content-container',
            source: '/api/integration/optimove-attribute/autocomplete?project_id=' + this.getProjectId(),
            searchOnFocus: {
                allowEmptyValue: true,
                allowFilledValue: true
            },
            select: function( event, ui ) {
                that.insertTag('{{ optimove.' + ui.item.value + ' }}');
                return false;
            }
        });

        $optimovePopup.find('.jsRemoveButton').click(function() {
            that.closeOptimovePopup();
        });

        $optimovePopup.mousedown(function(e) {
            e.stopPropagation();
        });

        $container.append($optimovePopup);
    };

    this.toggleOptimovePopup = function() {
        if ($optimovePopup.is(':visible')) {
            this.closeOptimovePopup();
        } else {
            this.openOptimovePopup();
        }
    };

    this.openOptimovePopup = function() {
        this.positionPopup($optimovePopup, $optimoveIcon);
        $optimovePopup.fadeIn(200);
        $optimovePopup.find('.jsAutocomplete').focus();
        $("body").bind('mousedown', this.closeOptimovePopup);
    };

    this.closeOptimovePopup = function() {
        $("body").unbind('mousedown', this.closeOptimovePopup);
        $optimovePopup.fadeOut(200);
        setTimeout(function() {
            $optimovePopup.find('.jsAutocomplete').val('');
        }, 0);
    };


    this.initSalesforceIcon = function() {
        if (options.salesforceButton) {
            $salesforceIcon = options.salesforceButton;
        } else {
            $salesforceIcon = $('<i class="icon iconp-salesforce"></i>');
            $toolbar.append($salesforceIcon);
        }
        $salesforceIcon.mousedown(function(){
            if (options.wysiwyg === 'redactor') {
                $container.find('textarea').eq(0).redactor('selection.save');
            }
        });
        $salesforceIcon.click(function(e){
            that.toggleSalesforcePopup();
            e.stopPropagation();
            return false;
        });
    };

    this.initSalesforcePopup = function() {
        $salesforcePopup = $(
            '<div class="personalizationPopup">'+
            '<label class="label1">'+t('all', 'Campaign__Salesforce_select_attribute')+'</label>'+
            '<br>'+
            '<input type="text" class="jsAutocomplete" />'+
            '</div>');

        $salesforcePopup.find('.jsAutocomplete').tagAutocomplete({
            appendTo: '#content-container',
            source: '/api/integration/salesforce-attribute/autocomplete?project_id=' + this.getProjectId(),
            searchOnFocus: {
                allowEmptyValue: true,
                allowFilledValue: true
            },
            select: function( event, ui ) {
                that.insertTag('{{ salesforce.' + ui.item.value + ' }}');
                return false;
            }
        });

        $salesforcePopup.find('.jsRemoveButton').click(function() {
            that.closeSalesforcePopup();
        });

        $salesforcePopup.mousedown(function(e) {
            e.stopPropagation();
        });

        $container.append($salesforcePopup);
    };

    this.toggleSalesforcePopup = function() {
        if ($salesforcePopup.is(':visible')) {
            this.closeSalesforcePopup();
        } else {
            this.openSalesforcePopup();
        }
    };

    this.openSalesforcePopup = function() {
        this.positionPopup($salesforcePopup, $salesforceIcon);
        $salesforcePopup.fadeIn(200);
        $salesforcePopup.find('.jsAutocomplete').focus();
        $("body").bind('mousedown', this.closeSalesforcePopup);
    };

    this.closeSalesforcePopup = function() {
        $("body").unbind('mousedown', this.closeSalesforcePopup);
        $salesforcePopup.fadeOut(200);
        setTimeout(function() {
            $salesforcePopup.find('.jsAutocomplete').val('');
        }, 0);
    };

    this.initConsentPreferencesIcon = function() {
        if (options.consentPreferencesButton) {
            $consentPreferencesIcon = options.consentPreferencesButton;
        } else {
            $consentPreferencesIcon = $('<i class="icon iconp-consent"></i>');

            if ($personalizationIcon && $personalizationIcon.length && !options.personalizationButton) {
                $personalizationIcon.after($consentPreferencesIcon);
            } else {
                $toolbar.append($consentPreferencesIcon);
            }
        }
        $consentPreferencesIcon.mousedown(function(){
            if (options.wysiwyg === 'redactor' && !options.consentPreferencesButton) {
                // Only save selection if this is a toolbar button, not a Redactor plugin button
                var $textarea = $container.find('textarea').eq(0);
                if ($textarea.length) {
                    try {
                        $textarea.redactor('selection.save');
                    } catch (e) {
                        // selection.save may not be available in all Redactor versions
                        // Continue without saving selection
                    }
                }
            }
        });
        $consentPreferencesIcon.click(function(e){
            that.toggleConsentPreferencesPopup();
            e.stopPropagation();
            return false;
        });
    };

    this.initConsentPreferencesPopup = function() {
        $consentPreferencesPopup = $(
            '<div class="personalizationPopup consentPreferencesPopup">'+
                '<label class="label1">'+t('all', 'CampaignForm_Field_SelectConsentPreference')+'</label>'+
                '<br>'+
                '<input type="text" class="jsAutocomplete helper" />'+
            '</div>');

        // Use REST API subdomain: https://rest.docker.local.xpu.sh:3043
        var restBaseUrl = (window.xp && window.xp.restUrl) ? window.xp.restUrl :
            window.location.protocol + '//rest.' + window.location.hostname + ':3043';
        var consentPreferencesUrl = restBaseUrl + '/projects/' + this.getProjectId() + '/consent-preferences';

        // Transform consent preferences data for autocomplete with grouping
        var transformConsentPreferences = function(data) {
            var items = [];
            var dataArray = data.items || data || [];
            if (Array.isArray(dataArray)) {
                dataArray.forEach(function(channel) {
                    if (channel.preferences && channel.preferences.length > 0) {
                        // Add group header
                        items.push({
                            value: '',
                            label: channel.label,
                            channel: channel.key,
                            isGroupHeader: true,
                            disabled: true
                        });
                        // Add preferences for this channel
                        channel.preferences.forEach(function(pref) {
                            items.push({
                                value: channel.key + '|||' + pref.name,
                                label: pref.name,
                                channel: channel.key,
                                channelLabel: channel.label,
                                name: pref.name
                            });
                        });
                    }
                });
            }
            return items;
        };

        $consentPreferencesPopup.find('.jsAutocomplete').tagAutocomplete({
            appendTo: '#content-container',
            params: null, // Skip buildURL since we're using a function source
            source: function(request, response) {
                // Build URL with search term parameter
                var url = consentPreferencesUrl;
                var term = request.term || '';
                if (term) {
                    url += (url.indexOf('?') === -1 ? '?' : '&') + 'name=' + encodeURIComponent(term);
                }

                // Fetch data from API with search term
                $.ajax({
                    url: url,
                    method: 'GET',
                    crossDomain: true,
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + (window.xp && window.xp.accessToken ? window.xp.accessToken : '')
                    },
                    success: function(data) {
                        // Transform the filtered response from backend
                        var items = transformConsentPreferences(data);
                        response(items);
                    },
                    error: function(xhr, status, error) {
                        console.error('Failed to load consent preferences:', error);
                        response([]);
                    }
                });
            },
            searchOnFocus: {
                allowEmptyValue: true,
                allowFilledValue: true
            },
            select: function(event, ui) {
                if (ui.item && ui.item.value && !ui.item.isGroupHeader) {
                    var parts = ui.item.value.split('|||');
                    var channel = parts[0];
                    var name = parts[1].replace(/'/g, "\\'");
                    that.insertTag("{{ user.preferences['"+channel+"']['"+name+"'] }}");
                    that.closeConsentPreferencesPopup();
                }
                return false;
            },
            _renderItem: function(ul, item) {
                var $el = $("<li>");
                if (item.isGroupHeader) {
                    // Render group header
                    $el.addClass("ui-autocomplete-group-header ui-state-disabled");
                    $el.append($("<strong>").text(item.label));
                } else {
                    // Render regular item
                    var $label = $("<div>").text(item.label);
                    if (item.channelLabel) {
                        var $channel = $("<span>").addClass('autocomplete-channel').text(item.channelLabel);
                        $label.prepend($channel);
                    }
                    var $link = $("<a>");
                    $link.html($label.html());
                    $el.append($link);
                }
                return $el.appendTo(ul);
            }
        });

        $consentPreferencesPopup.mousedown(function(e) {
            e.stopPropagation();
        });

        $container.append($consentPreferencesPopup);
    };

    this.toggleConsentPreferencesPopup = function() {
        if ($consentPreferencesPopup.is(':visible')) {
            this.closeConsentPreferencesPopup();
        } else {
            this.openConsentPreferencesPopup();
        }
    };

    this.openConsentPreferencesPopup = function() {
        this.positionPopup($consentPreferencesPopup, $consentPreferencesIcon);
        $consentPreferencesPopup.fadeIn(200);
        $consentPreferencesPopup.find('.jsAutocomplete').focus();
        $("body").bind('mousedown', this.closeConsentPreferencesPopup);
    };

    this.closeConsentPreferencesPopup = function() {
        $("body").unbind('mousedown', this.closeConsentPreferencesPopup);
        $consentPreferencesPopup.fadeOut(200);
        setTimeout(function() {
            $consentPreferencesPopup.find('.jsAutocomplete').val('');
        }, 0);
    };


    this.positionPopup = function ($popup, $icon) {
        let left = $icon.offset().left - $container.offset().left - $popup.width() / 2;
        if (left + $popup.width() > $container.width()) {
            $popup.css({
                left: 'auto',
                right: '0'
            });
        } else {
            $popup.css({
                left: left + 'px',
                right: 'auto'
            });
        }
    };


    this.insertTag = function(tag) {
        var input = $container.find('input:not(.helper)');
        if (input.length) {
            that.insertAtCursor(tag, input[0]);
            input.trigger('change');
        }
        if (options.wysiwyg === 'ckeditor') {
          options.ckeditor.insertHtml(tag);
        } else {
          var textarea = $container.find('textarea').eq(0);
          if (textarea.length) {
            if (options.wysiwyg === 'redactor') {
              textarea.redactor('selection.restore');
              textarea.redactor('insert.text', tag);
            } else {
              that.insertAtCursor(tag, textarea[0]);
              textarea.trigger('change');
            }
          }
        }

    };

    this.insertAtCursor = function(text, el) {
        var val = el.value, endIndex, startIndex, range;
        if (typeof el.selectionStart != 'undefined'
            && typeof el.selectionEnd != 'undefined') {
            startIndex = el.selectionStart;
            endIndex = el.selectionEnd;
            val = val.substring(0, startIndex) + text
                + val.substring(el.selectionEnd);
            el.value = val;
            el.selectionStart = el.selectionEnd = startIndex + text.length;
        } else if (typeof document.selection != 'undefined'
            && typeof document.selection.createRange != 'undefined') {
            el.focus();
            range = document.selection.createRange();
            range.text = text;
            range.select();
        }
    };


    this.initWysiwyg = function() {
        this.updateWysiwyg();
    };

    this.setWysiwyg = function(enabled) {
        options.wysiwyg = enabled;
        this.updateWysiwyg();
    };

    this.updateWysiwyg = function() {
        if (options.wysiwyg) {
            $container.addClass('contentEditorWysiwyg');
        } else {
            $container.removeClass('contentEditorWysiwyg');
        }
    };

    this.getProjectId = function() {
      return window.xp.isSpa ? window.vue.$store.state.app.project.id : window.xp.project.id
    }

    return this.init();
};



// WEBPACK FOOTER //
// ./src/jquery/widgets/contentEditor.js